import { SET_URI } from './types';

export const setUri = (value) => {
	return {
		type: SET_URI,
		payload: value
	};
};
